import Dialog from 'click-controls/controls/dialog';
import Toastify from 'click-controls/controls/toastify';
import ToastifyStore from 'click-controls/controls/toastify/toastify-store';
import ChangePassword from 'core/auth/help/change-password';
import { action } from 'mobx';
import React from 'react';

interface IProps {
  openDialog: boolean;
  handleUpdateResult?: (type: string, err: any) => void;
  store: UserDialogStore;
}

class ChangePasswordDialog extends React.Component<IProps> {
  render() {
    const { message, messageType, openNotifyPanel, closeNotifyPanel } = ToastifyStore;
    return (
      <Dialog
        title={'Change Password'}
        headerClass={'text-center'}
        width="1/3"
        isOpen={this.props.openDialog}
        onClose={this.onClose}
        centered={true}
        closable={true}
        isDismissable={false}
        footer={<></>}
      >
        <>
          <Toastify
            open={openNotifyPanel}
            message={message}
            type={messageType}
            duration={3000}
            onClose={closeNotifyPanel}
          />
          <ChangePassword
            containerClass="w-full"
            updateBtnClass="float-right w-[160px]"
            updateBtnText="Update Password"
            isEditMode={true}
            handleUpdateResult={this.props.handleUpdateResult}
          ></ChangePassword>
        </>
      </Dialog>
    );
  }

  @action.bound
  private onClose(): void {
    this.props.store.isChangePassword = false;
  }
}

export default ChangePasswordDialog;
